import actionTypes from '../constants/action-types';
import {
  UPDATE_STATIC_ONLY,
  UPDATE_LIVE_ONLY,
  UPDATE_BOTH,
} from '../../hdrm/constants/update-strategies';

const getMutualStrategy = (actions) => {
  const strategies = [
    ...new Set(
      actions
        .map(({ payload }) => payload && payload.options && payload.options.strategy)
        .filter((strategy) => !!strategy)
    ),
  ];

  if (strategies.includes(UPDATE_LIVE_ONLY)) {
    if (strategies.length > 1) {
      throw new Error(`Actions with non compatible strategies are passed to bulkViewActions`);
    }

    return UPDATE_LIVE_ONLY;
  }

  if (strategies.includes(UPDATE_STATIC_ONLY)) {
    return UPDATE_STATIC_ONLY;
  }

  return UPDATE_BOTH;
};

const bulkViewActions = (actions, options = {}) => {
  const strategy = getMutualStrategy(actions);
  const uniqueGlobalsToUpdate = {};

  actions.forEach(({ payload }) => {
    if (payload && payload.globalsToUpdate) {
      payload.globalsToUpdate.forEach((global) => {
        uniqueGlobalsToUpdate[global.id] = global;
      });
    }
  });

  return {
    type: actionTypes.BULK_VIEW_ACTIONS,
    payload: {
      actions,
      options: { strategy, ...options },
      globalsToUpdate: Object.values(uniqueGlobalsToUpdate),
    },
  };
};

export default bulkViewActions;
